import React, { Fragment, useEffect } from "react";
import { connect } from "react-redux";

import DataSourceMapping from "./FieldMapping";
import { updateTemplateFormFieldsList } from "../../actions/FieldsSetting/fieldsSettingActions";
import { fetchMetaFieldAction } from "../../actions/MetaFieldActions";
import FieldsData from "./FieldsData/FieldsData";
import { LOADING_MSG, FIELDS } from "../../constants";
import LZLoader from "../../commonComponents/LZLoader";

const { DATA_STUDIO_VIEW } = FIELDS;

const DataStudio = ({
  syncDataSource,
  dataStudioView,
  isTemplate,
  templateId,
  updateFormFields,
  fetchFormFields,
  objectId,
}) => {
  useEffect(() => {
    document.title = "LegalZoom Data Studio | Integrations";
    if (isTemplate && templateId) {
      updateFormFields();
    } else {
      fetchFormFields();
    }
  }, [fetchFormFields, isTemplate, templateId, updateFormFields, objectId]);
  let studioView = null;
  if (dataStudioView === DATA_STUDIO_VIEW.CONFIG_VIEW) {
    studioView = <DataSourceMapping templateId={templateId} />;
  } else if (syncDataSource && syncDataSource.status === "STARTED") {
    studioView = <LZLoader label={LOADING_MSG.FORM_DATA} />;
  } else if (syncDataSource && syncDataSource.status === "DONE") {
    studioView = <FieldsData />;
  } else {
    studioView = <DataSourceMapping templateId={templateId} />;
  }
  return (
    // Switch integrations here
    <Fragment>{studioView}</Fragment>
  );
};

const mapStateToProps = state => {
  const { syncDataSource, dataStudioView } = state.FieldsSettingStore;
  const { template: { fields_used: fieldsUsed, object_id: objectId } = {} } =
    state.TemplateStore;

  return { syncDataSource, dataStudioView, fieldsUsed, objectId };
};

const mapDispatchToProps = {
  updateFormFields: updateTemplateFormFieldsList,
  fetchMetaFields: fetchMetaFieldAction,
};
export default connect(mapStateToProps, mapDispatchToProps)(DataStudio);
